export const getBdWsMemberEmail = (identity) => {
  const { trialLimits, subscriptionData } = identity;

  if (subscriptionData?.bdWsMemberEmail)
    return subscriptionData?.bdWsMemberEmail;
  return trialLimits?.bdWsMemberEmail || "";
};
